import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-white dark:bg-black border-t border-gray-200 dark:border-gray-800 py-4 px-6">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-start md:items-center text-sm text-gray-600 dark:text-gray-400">
        <div className="mb-3 md:mb-0">
          <p>&copy; {new Date().getFullYear()} Anime Forever Tamil. All rights reserved.</p>
        </div>

        <div className="flex flex-col md:flex-row md:items-center md:space-x-6 w-full md:w-auto">
          <div className="flex flex-wrap gap-3 items-center">
            <Link
              to="/privacy-policy"
              className="hover:text-blue-600 dark:hover:text-blue-400 transition-colors"
            >
              Privacy Policy
            </Link>

            <a
              href="https://www.youtube.com/t/terms"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-blue-600 dark:hover:text-blue-400 transition-colors"
            >
              YouTube Terms
            </a>

            <a
              href="https://developers.facebook.com/docs/plugins/embedded-video-player/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-blue-600 dark:hover:text-blue-400 transition-colors"
            >
              Facebook Embed
            </a>

            <a
              href="https://developers.facebook.com/policy/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-blue-600 dark:hover:text-blue-400 transition-colors"
            >
              Facebook Platform Policy
            </a>
          </div>

          <div className="mt-2 md:mt-0 text-xs text-gray-600 dark:text-gray-400 md:ml-4">
            Content provided by YouTube and Facebook
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
